export default "__VITE_ASSET__ff256b4c__"